import { render, staticRenderFns } from "./MododeJogo.vue?vue&type=template&id=8ffee70e&scoped=true&"
import script from "./MododeJogo.vue?vue&type=script&lang=js&"
export * from "./MododeJogo.vue?vue&type=script&lang=js&"
import style0 from "./MododeJogo.vue?vue&type=style&index=0&id=8ffee70e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffee70e",
  null
  
)

export default component.exports